// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export enum Format {
  csv = '.csv'
}

export const FORMAT_LABELS = {
  [Format.csv]: 'CSV'
};